<template>
  <MoleculeNotFound/>
</template>

<script>
export default {
  name: 'OrganismNotFound',

  components: {
    MoleculeNotFound: () => import('@/components/molecules/MoleculeNotFound')
  }
}
</script>
